import React from 'react';
import {connect} from "react-redux";
import {DOMAIN} from "../PricesCalendarContainer";
import Translator from "../../helpers/Translator";
import DateTimeFormatter from "../../helpers/DateTimeFormatter";
import PriceFormatter from "../../helpers/PriceFormatter";
import Matrix from "./Matrix";
import IframeHelper from "../../helpers/IframeHelper";
import PriceHelper from "../../helpers/PriceHelper";
import MarkupHelper from "../../helpers/MarkupHelper";

class RoundTripMatrix extends Matrix {
    constructor(props) {
        super(props);
        this.cheapest = []; // array of {price: float, departureDate: string, returnDate: string}
    }

    assembleDates(dates) {
        let formattedDates = [];
        const today = DateTimeFormatter.createDate(DateTimeFormatter.getCurrentDate());
        Object.keys(dates).filter(function (date) {
            return today <= DateTimeFormatter.createDate(date);
        }).map((departureDate) => {
            formattedDates[departureDate] = {};
            Object.keys(dates[departureDate]).map((returnDate) => {
                const departureDateObject = DateTimeFormatter.createDate(departureDate);
                const returnDateObject = DateTimeFormatter.createDate(returnDate);

                let price = dates[departureDate][returnDate];
                if (departureDate === this.props.parameters['search-params'].departureDate
                    && returnDate === this.props.parameters['search-params'].returnDate
                    && this.props.cheapest && this.props.cheapest.length > 0
                    && this.props.selectedMatrix === this.props.parameters['search-params'].departureCity
                ) {
                    let amountDisplay = this.props.cheapest[0].general.amountDisplay;
                    if (MarkupHelper.shouldHideOvercharge(amountDisplay, this.props.parameters['agencySettings'])) {
                        price = this.props.cheapest[0].general.averageFlightPricePerPerson + this.props.cheapest[0].general.serviceFee;
                    } else {
                        price = this.props.cheapest[0].general.averageFlightPricePerPerson;
                    }
                }
                price !== null && this.cheapest.push(price);

                formattedDates[departureDate][returnDate] = {
                    departureKey: departureDate,
                    returnKey: returnDate,
                    departureDate: DateTimeFormatter.getShortDate(departureDateObject, this.props.parameters['date-format']),
                    returnDate: DateTimeFormatter.getShortDate(returnDateObject, this.props.parameters['date-format']),
                    departureWeekday: this.translator.trans(DateTimeFormatter.getWeekday(departureDateObject.getDay())),
                    returnWeekday: this.translator.trans(DateTimeFormatter.getWeekday(returnDateObject.getDay())),
                    price: price
                };

                return true;
            });

            return true;
        });

        return formattedDates;
    }

    renderDate(date) {
        return (
            <div className="col date header">{date.returnDate} {date.returnWeekday}.</div>
        );
    }

    renderDatesHeader(dates) {
        let renderDates = [];
        let firstDate = Object.keys(dates)[0];
        Object.keys(dates[firstDate]).map((returnDate) => {
            renderDates.push(this.renderDate(dates[firstDate][returnDate]));

            return true;
        });

        return (
            <div className="row">
                <div className="col title col-title--corner">
                    <span className="corner-return">{this.translator.trans('Return')}</span>
                    <span className="corner-departure">{this.translator.trans('Departure')}</span>
                </div>
                {renderDates}
            </div>
        );
    }

    renderPrice(active, date) {
        if (!date.price) {
            return (
                <div className={`col date ${active ? 'active' : ''}`}>
                    <a target="_parent" href={IframeHelper.link(this.props.parameters, this.getPriceUrl(date))}>
                        <span className="icon-search"></span>
                    </a>
                </div>
            );
        }

        return (
            <div className={`col date ${active ? 'active' : ''} ${!active && this.isCheapestPrice(date) ? 'cheapest' : ''}`}>
                <a target="_parent" href={IframeHelper.link(this.props.parameters, this.getPriceUrl(date))}>
                    <span {...this.priceFormatter.format(date.price)}></span>
                </a>
            </div>
        );
    }

    isCheapestPrice(date) {
        const cheapestPrice = Math.floor(this.cheapest * 100) / 100;
        const datePrice = Math.floor(date.price * 100) / 100;

        return cheapestPrice === datePrice;
    }

    getPriceUrl(date) {
        const url = this.props.parameters['url'];
        let urlParts = url.split('/');

        for (let i = 0; i < urlParts.length; i++) {
            let parts = urlParts[i].split(':');
            if (parts[0] === 'wfilter') {
                delete urlParts[i];
                continue;
            }

            if (parts[0] === 'departureDate' || parts[0] === 'departure_date') {
                parts[1] = date.departureKey;
                parts = parts.join(':');
                urlParts[i] = parts;
            }

            if (parts[0] === 'returnDate' || parts[0] === 'comeback_date') {
                parts[1] = date.returnKey;
                parts = parts.join(':');
                urlParts[i] = parts;
            }
        }

        return urlParts.join('/');
    }

    renderPriceRows(dates) {
        let rows = [];
        Object.keys(dates).map((departureDate) => {
            let row = [];
            Object.keys(dates[departureDate]).map((returnDate) => {
                row.push(
                    this.renderPrice(this.props.parameters['search-params'].departureDate === departureDate && this.props.parameters['search-params'].returnDate === returnDate, dates[departureDate][returnDate])
                );

                return true;
            });

            const firstDay = dates[departureDate][Object.keys(dates[departureDate])[rows.length]];

            rows.push(
                (
                    <div className="row">
                        <div className="col title">{firstDay.departureDate} {firstDay.departureWeekday}</div>
                        {row}
                    </div>
                )
            );

            return true;
        });

        return rows;
    }

    render() {
        if (!this.props.matrix) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);
        this.cheapest = []; // array of {price: float, departureDate: string, returnDate: string}

        const dates = this.assembleDates(this.props.matrix);
        this.cheapest = Math.min(...this.cheapest);

        return (
            <div className={this.props.isMatrixCollapsed ? 'd-none' : ''}>
                {this.renderDatesHeader(dates)}
                {this.renderPriceRows(dates)}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        parameters: state.ParametersReducer.parameters,
        cheapest: state.FlightsReducer.cheapest,
        selectedMatrix: state.MatrixReducer.selectedDepartureCity,
        isMatrixCollapsed: state.MatrixReducer.isMatrixCollapsed,
    }
}

export default connect(mapStateToProps)(RoundTripMatrix);



// WEBPACK FOOTER //
// ./src/components/pricesCalendar/RoundTripMatrix.js